import React, {useContext, useEffect, useRef, useState} from 'react';
import Frame from "../components/layout/Frame";
import FrameV2 from "../components/layout/Frame";
import {useLocation} from "react-router-dom";
import {locationContext} from "../App";
import {getBrokerURI} from "../api/apiClient";
import base64 from "base-64";
import {Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";

const DashBrokerServer = () => {
  const location = useLocation();
  const {setLocation} = useContext(locationContext);
  const refIFrame = useRef(null);

  const [stIFrame, setIFrame] = useState({
    uri: null,
    token: null
  });

  const [stURI, setURI] = useState('');

  const updateIFrame = () => {
    getBrokerURI().then(res => {
      if (res.data.data != undefined) {
        let state = {
          uri: res.data.data.iframeUrlEncode,
          token: res.data.data.tokenEncode
        }
        setIFrame(state)
      }
    })
  }

  useEffect(() => {
    updateIFrame();
  }, [])

  useEffect(() => {
    let uri = stIFrame.uri;
    let token = stIFrame.token;
    if (uri != null && token != null) {
      uri = base64.decode(uri);
      token = base64.decode(token);

      setURI(uri + token);
      console.log(uri + token);
    }
  }, [stIFrame])


  useEffect(() => {
    setLocation(location.pathname);
  }, [location, setLocation]);

  const resizeIframe = () => {
    refIFrame.current.style.height = refIFrame.current.contentWindow.document.documentElement.scrollHeight + 'px';
    console.log(refIFrame);
  }

  return (
      <FrameV2
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Row>
          <iframe ref={refIFrame}
                  src={stURI}
                  height={'1600'}
              // width={'100'}
                  style={{width: '100vw'}}
                  onLoad={resizeIframe}></iframe>
        </Row>

      </FrameV2>
  );
};

export default DashBrokerServer;
